import React from "react";
import PropTypes from "prop-types";
import * as dropEffects from "./DropEffects";
import './DropTarget.scss'

const insideStyle = {
    backgroundColor: "#cccccc",
    opacity: 0.5,
};

const DropTarget = (props: { dropEffect: any; onItemDropped: (arg0: any, arg1: any) => void; children: React.ReactNode; }) => {
    const [isOver, setIsOver] = React.useState(false);

    const dragOver = (ev: { preventDefault: () => void; dataTransfer: { dropEffect: any; }; }) => {
        ev.preventDefault();
        ev.dataTransfer.dropEffect = props.dropEffect;
    };

    const drop = (ev: { dataTransfer: { getData: (arg0: string) => any; }; }) => {
        const droppedItem = ev.dataTransfer.getData("drag-item");
        const droppedType = ev.dataTransfer.getData("drag-type");
        if (droppedItem && droppedType) {
            props.onItemDropped(droppedItem,droppedType);
        }
        setIsOver(false);
    };

    const dragEnter = (ev: { dataTransfer: { dropEffect: any; }; }) => {
        ev.dataTransfer.dropEffect = props.dropEffect;
        setIsOver(true);
    };

    const dragLeave = () => setIsOver(false);

    return (
            <div
                className="d-flex justify-content-center drop-target-items"
                onDragOver={dragOver}
                onDrop={drop}
                onDragEnter={dragEnter}
                onDragLeave={dragLeave}
                style={{minHeight:'100px', border: isOver ? '1px dotted gray' : 'none', ...(isOver ? insideStyle : {}) }}
            >
                {props.children}
            </div>
    );
};

DropTarget.propTypes = {
    onItemDropped: PropTypes.func.isRequired,
    dropEffect: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

DropTarget.defaultProps = {
    dropEffect: dropEffects.All,
};

export default DropTarget;
